import { OnboardingDetailsType } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { BorrowerKYC } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/BorrowerKYC';
import { BusinessKYC } from '@/components/modules/KYC/KYCLoan/BusinessKYC/BusinessKYC';
import { useKYCInformation } from '@/components/modules/KYC/KYCLoan/hooks/useKYCInformation';
import { ModuleCorePermissionProps } from '@/config/types';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const KYCLoan = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { loanId } = useParams();

  if (!loanId) return null;

  const { loan, currentParticipantOnboardingDetails, loading } = useKYCInformation({ loanId });

  useSetPageLoadingWhenRequesting('KYC_LOAN', [loading]);

  if (!currentParticipantOnboardingDetails || !loan) {
    return null;
  }

  return (
    <>
      {currentParticipantOnboardingDetails.type === OnboardingDetailsType.BORROWER && (
        <BorrowerKYC
          loanId={loanId}
          agentId={loan.agentId}
          editModeAllowed={canEdit}
          onboardingDetails={currentParticipantOnboardingDetails}
        />
      )}
      {currentParticipantOnboardingDetails.type === OnboardingDetailsType.BUSINESS && (
        <BusinessKYC
          loanId={loanId}
          editModeAllowed={canEdit}
          onboardingDetails={currentParticipantOnboardingDetails}
        />
      )}
    </>
  );
};

export const KYCLoanModule = withPermissionsModule(KYCLoan);
